import { functions } from '../firebase/firebase'

export const fulcrumRequest = functions.httpsCallable('fulcrum-request')
